// extracted by mini-css-extract-plugin
export default {"icon":"QQRp2f","optionSubtitle":"LISYNh"};